import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect } from "react"
import { sendInviteSms } from "../../../features/joblist/jobListSlice"
import { useState } from "react"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: auto;
        height: auto;
        padding: 50px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        p{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-md);
            margin-block: 5px;
        }

        .btns{
            display: flex;
            align-items: center;
            margin-top: 25px;
            width: 100%;
            button{
                margin-right: 10px;
                width: auto;
            }
        }
    }

`
    
const JobListInviteModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    const {devamliAracItem, driverSearchData} = useSelector((state) => state.jobList)
    const {topBarCompanyInfo} = useSelector((state)=> state.companyProfile)
    const [sendedPhone, setSendedPhone] = useState("")

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    // const invitePhoneNumber = ((devamliAracItem?.phoneNumber?.startsWith('90') || devamliAracItem?.phoneNumber?.startsWith('+90')) ? devamliAracItem?.phoneNumber?.slice(2) : devamliAracItem?.phoneNumber) || driverSearchData?.phoneNumber
    // phoneNumber.startsWith('90') ? phoneNumber?.slice(2) : phoneNumber
    
    useEffect(() => {
        if(devamliAracItem){
            if(devamliAracItem?.phoneNumber?.startsWith('90') || devamliAracItem?.phoneNumber?.startsWith('+90')){
                setSendedPhone(devamliAracItem?.phoneNumber?.slice(2))
            }else{
                setSendedPhone(devamliAracItem?.phoneNumber)
            }
        }else{
            setSendedPhone(driverSearchData?.phoneNumber)
        }
    }, [devamliAracItem, driverSearchData])
    

  return (
    <Container>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <p>Sürücüler & Araçlar Listenize başarıyla kaydedilmiştir.</p>
            <p>Kamyoon Uygulamasına ön kayıt yapılmıştır.</p>
            <p>Sürücü; mobil uygulamayı indirip üyelik kaydını tamamladığında;</p>
            <p>Yük verdiğinizde sefer boyunca üyenin konumunu takip edebilecek ve teslim evraklarını görebileceksiniz.</p>
            <div className="btns">
                <Button width="150px" handleClick={() => { dispatch(sendInviteSms({phoneNumber: sendedPhone, companyName: topBarCompanyInfo.companyName})) }} padding="10px" background="#fff" color={"#E85446"}>Kamyoon Uygulamasına Üye Olmaya Davet Et</Button>
                <Button width="150px" handleClick={() => dispatch(showModal(null))} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
            </div>
            
        </div>
    </Container>
  )
}

export default JobListInviteModal